import actionCreatorFactory from "typescript-fsa";
import { RawPageData } from "../../../../its-pages/src";

const actionCreator = actionCreatorFactory('STUDENT_CLIENT_RESULTS');

export const studentProblemResult = actionCreator<RawPageData>('PROBLEM_RESULTS');
/** pass in whether grade should also be sent */
export const studentCompletedModule = actionCreator<boolean>('MODULE_COMPLETE');
/** pass in whether grade should also be sent */
export const studentSurveyClicked = actionCreator<boolean>('SURVEY_CLICKED');
export const studentProblemSetStart = actionCreator<void>('PROBLEM_SET_START');